import { Button, Stack } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { MouseEvent, useState } from 'react'
import { EquipmentResponse } from '../../../../store/equipments/equipments.types'
import {
  Content,
  ItemContainer,
  Meta,
  UnitNumber,
} from './equipment-list-item.styles'
import EquipmentAddDialog from '../../equipment-add-dialog/equipment-add-dialog.component'
import EquipmentDeleteDialog from '../../equipment-delete-dialog/equipment-delete-dialog.component'

type EquipmentListItemProps = {
  equipment: EquipmentResponse
  isSelected: boolean
  handleEquipmentSelect: () => void
}

const actionButtonSx = {
  flex: 1,
  minWidth: 0,
  borderRadius: '8px',
  textTransform: 'none',
  fontWeight: 600,
  paddingX: '10px',
  paddingY: '6px',
} as const

const EquipmentListItem = ({
  equipment,
  isSelected,
  handleEquipmentSelect,
}: EquipmentListItemProps) => {
  const [updateOpen, setUpdateOpen] = useState(false)
  const [deleteOpen, setDeleteOpen] = useState(false)

  const handleUpdate = (e: MouseEvent) => {
    e.stopPropagation()
    handleEquipmentSelect()
    setUpdateOpen(true)
  }

  const handleDelete = (e: MouseEvent) => {
    e.stopPropagation()
    handleEquipmentSelect()
    setDeleteOpen(true)
  }

  return (
    <ItemContainer $selected={isSelected} onClick={handleEquipmentSelect}>
      <Content $selected={isSelected}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
        >
          <UnitNumber>{equipment.unitNumber}</UnitNumber>
          {equipment.stateProvince ? (
            <Meta $selected={isSelected}>{equipment.stateProvince}</Meta>
          ) : null}
        </Stack>
        <Meta $selected={isSelected}>
          {equipment.licensePlateNumber || ''}
        </Meta>
      </Content>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          padding: '8px 12px 12px',
          bgcolor: isSelected ? '#E8F3FC' : 'common.white',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Button
          variant="outlined"
          startIcon={<CheckCircleOutlineIcon />}
          onClick={handleUpdate}
          sx={{
            ...actionButtonSx,
            borderColor: 'primary.main',
            color: 'primary.main',
            '&:hover': {
              borderColor: 'primary.dark',
              bgcolor: 'rgba(25, 118, 210, 0.04)',
            },
          }}
        >
          Update Equipment
        </Button>
        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteOutlineIcon />}
          onClick={handleDelete}
          sx={actionButtonSx}
        >
          Delete Equipment
        </Button>
      </Stack>
      {updateOpen && (
        <EquipmentAddDialog
          open={updateOpen}
          handleClose={() => setUpdateOpen(false)}
          equipmentType={equipment.equipmentType}
          equipment={equipment}
        />
      )}
      {deleteOpen && (
        <EquipmentDeleteDialog
          open={deleteOpen}
          handleClose={() => setDeleteOpen(false)}
          equipment={equipment}
        />
      )}
    </ItemContainer>
  )
}

export default EquipmentListItem
